/* =============================================================
 * MENJUNJES — Motion engine
 *
 * Subtle scroll-driven reveals. Single-trigger (does not re-animate
 * on scroll-back). Respects prefers-reduced-motion.
 *
 * Auto-targets common section types so we don't have to sprinkle
 * classes everywhere. Selectors are scoped to Menjunjes' homepage
 * + PDP rhythm — extend list below if new section types ship.
 *
 * Class contract:
 *   .menjunjes-reveal           — initial hidden state (opacity 0, +16px Y)
 *   .menjunjes-reveal.is-revealed — animated to natural state
 *   .menjunjes-reveal--stagger > * — children animate in series
 * ============================================================= */
(function () {
  'use strict';

  // Skip entirely if user prefers reduced motion
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  // Skip if IntersectionObserver isn't available (very old browsers)
  if (!('IntersectionObserver' in window)) {
    return;
  }

  // Selectors to auto-mark for reveal. Each entry: [section-class-suffix, child-selector-or-null]
  // null child = whole section is the reveal unit.
  // child-selector = direct content children get individual reveals (staggered).
  // Targets — sections that DON'T already have Prestige's reveal-on-scroll baked in.
  // DO NOT add featured-collections / product-card / collection-banner / blog-posts /
  // media-grid / slideshow here — Prestige animates those itself, double-animation
  // leaves cards stuck at intermediate opacity (regression caught 2026-05-05).
  var TARGETS = [
    ['shopify-section--brand-story', '.image-with-text-block, [class*="rich-text"], .container'],
    ['shopify-section--first-time', null],
    ['shopify-section--menjunjes-marks', '.menjunjes-marks__cell'],
    ['shopify-section--menjunjes-video-feature', '.menjunjes-video-feature__content, .menjunjes-video-feature__media'],
    ['shopify-section--multi-column', '.multi-column__item, [class*="multi-column__item"]'],
    ['shopify-section--menjunjes-press-bar', null],
  ];

  function markForReveal(el, isStagger) {
    if (el.classList.contains('menjunjes-reveal') || el.classList.contains('is-revealed')) {
      return;
    }
    el.classList.add('menjunjes-reveal');
    if (isStagger) {
      el.classList.add('menjunjes-reveal--stagger');
    }
  }

  function collectTargets() {
    var targets = [];
    TARGETS.forEach(function (entry) {
      var sectionSelector = '.' + entry[0];
      var childSelector = entry[1];
      var sections = document.querySelectorAll(sectionSelector);

      sections.forEach(function (section) {
        if (childSelector) {
          var children = section.querySelectorAll(childSelector);
          if (children.length > 0) {
            children.forEach(function (child) {
              markForReveal(child, false);
              targets.push(child);
            });
            return;
          }
        }
        markForReveal(section, true);
        targets.push(section);
      });
    });
    return targets;
  }

  function init() {
    var targets = collectTargets();
    if (targets.length === 0) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        rootMargin: '0px 0px -8% 0px',  // trigger slightly before element fully in view
        threshold: 0.05,
      }
    );

    targets.forEach(function (t) { observer.observe(t); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
